module.exports = __webpack_public_path__ + "img/report.da6fb30a.png";